export const zIndices = {
  hide: -1,
  base: 0,
  docked: 10,
  highBackdrop: 99,
  high: 100,
  highestBackdrop: 999,
  highest: 1000,
};
